document.addEventListener("turbo:morph", () => {
  document.querySelectorAll("svg").forEach((svg) => {
    svg.outerHTML = svg.outerHTML
  })
})
